import axiosInstance from '../utils/axiosConfig';

export interface Chain {
  id: number;
  name: string;
  contact_info?: string;
  description?: string;
}

export const listChains = async () => {
  const { data } = await axiosInstance.get<Chain[]>('/api/v1/chains');
  return data;
};

export const getChain = async (id: number) => {
  const { data } = await axiosInstance.get<Chain>(`/api/v1/chains/${id}`);
  return data;
};

export const createChain = async (payload: Omit<Chain, 'id'>) => {
  const { data } = await axiosInstance.post<Chain>('/api/v1/chains', payload);
  return data;
};

export const updateChain = async (id: number, payload: Chain) => {
  const { data } = await axiosInstance.put<Chain>(`/api/v1/chains/${id}`, payload);
  return data;
};

export const deleteChain = async (id: number) => {
  await axiosInstance.delete(`/api/v1/chains/${id}`);
}; 